import { render, staticRenderFns } from "./sales-summary.vue?vue&type=template&id=12dee0c6&scoped=true&"
import script from "./sales-summary.vue?vue&type=script&lang=js&"
export * from "./sales-summary.vue?vue&type=script&lang=js&"
import style0 from "./sales-summary.vue?vue&type=style&index=0&id=12dee0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dee0c6",
  null
  
)

export default component.exports